import "./ConnectWithUs.module.css";
import Navigation from "@/reusable_sections/Header";
import Inquiry from "./sections/Inquiry";
import Office from "./sections/Office";
import Footer from "@/reusable_sections/Footer";
export default function ConnectWithUsPage() {
  return <div>
      <Navigation />
      <Inquiry />
      <Office />
      <Footer />
    </div>;
}